import { render, staticRenderFns } from "./Fallback.vue?vue&type=template&id=ae5e14aa&scoped=true&"
import script from "./Fallback.vue?vue&type=script&lang=js&"
export * from "./Fallback.vue?vue&type=script&lang=js&"
import style0 from "./Fallback.vue?vue&type=style&index=0&id=ae5e14aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5e14aa",
  null
  
)

export default component.exports